'use client';

import type { ApolloQueryResult } from '@apollo/client';
import { createContext, type FC, type PropsWithChildren, useEffect, useRef } from 'react';
import type { TariffsQuery } from '../../types/generated';

export type Tariff = TariffsQuery['tariffs'][number];
export type TariffPair = [Tariff, Tariff];
export type TariffsQueryTransformed = Omit<TariffsQuery, 'tariffs'> & {
  tariffs: TariffPair[];
};

export const Context = createContext<Promise<ApolloQueryResult<TariffsQueryTransformed>> | null>(null);

export const GasTariffsContext: FC<
  PropsWithChildren & {
    tariffs: Promise<ApolloQueryResult<TariffsQueryTransformed>> | null;
  }
> = ({ children, tariffs }) => {
  const cachedTariffs = useRef(tariffs);

  useEffect(() => {
    if (tariffs !== null) {
      cachedTariffs.current = tariffs;
    }
  }, [tariffs]);

  return <Context.Provider value={cachedTariffs.current}>{children}</Context.Provider>;
};
